import clsx from "clsx";

interface Props {
    className?: string
    FillColor?: string
}

export default function LinkedIn({className, FillColor = 'black'}:Props) {
    return (
        <svg width="24" height="24" className={clsx(className, FillColor)}>
            <path d="M7.19 8.79H3.576a.29.29 0 0 0-.29.291V20.69c0 .16.13.29.29.29H7.19c.16 0 .29-.13.29-.29V9.08a.29.29 0 0 0-.29-.29zM5.384 3.02A2.386 2.386 0 0 0 3 5.402a2.386 2.386 0 0 0 2.384 2.383 2.385 2.385 0 0 0 2.383-2.383A2.385 2.385 0 0 0 5.384 3.02zM16.381 8.502c-1.451 0-2.524.624-3.175 1.333v-.754a.29.29 0 0 0-.29-.29h-3.46a.29.29 0 0 0-.291.29V20.69c0 .16.13.29.29.29h3.606c.16 0 .29-.13.29-.29v-5.744c0-1.935.526-2.69 1.875-2.69 1.47 0 1.586 1.21 1.586 2.79v5.644c0 .16.13.29.29.29h3.608c.16 0 .29-.13.29-.29v-6.368c0-2.878-.549-5.82-4.619-5.82z"/>
        </svg>
    )
}
